export default function RiskMeter({ score }: { score: number }) {
  const color = score > 70 ? "#10b981" : score > 45 ? "#f59e0b" : "#ef4444";
  return (
    <div className="flex items-center gap-2">
      <div className="flex-1 h-1.5 bg-slate-100 rounded-full overflow-hidden">
        <div style={{ width:`${score}%`, background:color }} className="h-full rounded-full transition-all duration-500"/>
      </div>
      <span className="text-xs font-medium min-w-[28px]" style={{ color }}>{score}</span>
    </div>
  );
}
